import React from 'react';
import { RouteObject } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { PathUtil } from '../util/PathUtil';

const PatientStatusDataChangeContainer = React.lazy(
  () => import('../../data-change/data-change-patient-status/container/PatientStatusDataChangeContainer'),
);

const EditPatientMedicationStatusContainer = React.lazy(
  () => import('../../patient-status/container/EditPatientMedicationStatusContainer'),
);
const EditPatientStudyStatusContainer = React.lazy(
  () => import('../../patient-status/container/EditPatientStudyStatusContainer'),
);
const UpdateStudyDefinedStatusDrawerRoute = React.lazy(
  () =>
    import(
      '../../patient-study-defined-status/study-defined-status-card/container/UpdateStudyDefinedStatusDrawerRoute'
    ),
);
const EditPatientInformationContainer = React.lazy(
  () => import('../../patient-management/edit-patient/container/EditPatientInformationContainer'),
);

const PatientActivityContainer = React.lazy(() => import('../../patient-account/container/PatientActivityContainer'));

export const PatientOverviewDrawerRoutes: RouteObject[] = [
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_OVERVIEW, CspPath.PATIENT_OVERVIEW_PATIENT_STATUS_EDIT, true),
    element: <EditPatientStudyStatusContainer />,
  },
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_OVERVIEW, CspPath.PATIENT_OVERVIEW_MEDICATION_STATUS_EDIT, true),
    element: <EditPatientMedicationStatusContainer />,
  },
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_OVERVIEW, CspPath.PATIENT_OVERVIEW_PATIENT_STATUS_DATA_CHANGE, true),
    element: <PatientStatusDataChangeContainer />,
  },
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_OVERVIEW, CspPath.PATIENT_OVERVIEW_SDS_DATA_CHANGE, true),
    element: <PatientStatusDataChangeContainer />,
  },
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_OVERVIEW, CspPath.PATIENT_OVERVIEW_SDS_CONFIRM, true),
    element: <UpdateStudyDefinedStatusDrawerRoute />,
  },
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_OVERVIEW, CspPath.PATIENT_OVERVIEW_EDIT_DETAILS, true),
    element: <EditPatientInformationContainer />,
  },
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_OVERVIEW, CspPath.PATIENT_OVERVIEW_ACTIVITY_DETAILS, true),
    element: <PatientActivityContainer />,
  },
];
